import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TimerIcon from '@material-ui/icons/Timer';
import {
  getStatusLabel,
  IStatusMetrics,
  statusesColors,
  statusesDashboard,
} from 'interfaces/dashboard';
import CircleIcon from 'mdi-react/CircleIcon';
import React, { memo } from 'react';
import { Cell, Label, Pie, PieChart } from 'recharts';

import Card from '../Component/Card';
import CardActionArea from '@material-ui/core/CardActionArea';

interface IProps {
  metrics: IStatusMetrics;
  total: number;
  onClick?: () => void;
}

const useStyles = makeStyles((theme) => ({
  content: {
    padding: theme.spacing(1),
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    '&:last-child': {
      paddingBottom: theme.spacing(1),
    },
  },
  middleText: theme.typography.subtitle2,
  iconStatus: {
    verticalAlign: 'middle',
  },
  text: {
    textTransform: 'initial',
    lineHeight: 1.5,
  },
  center: {
    justifyContent: 'center',
    display: 'flex',
  },
}));

const Status = memo<IProps>((props) => {
  const classes = useStyles();
  const { metrics, total, onClick } = props;

  const getMetrics = () => {
    const _metrics =
      total > 0
        ? [metrics, { name: 'Outros', value: total - metrics.value }]
        : [
            metrics,
            {
              value: 1,
              status: 'NO_DOCUMENTS',
            },
          ];
    return _metrics;
  };

  return (
    <CardActionArea onClick={onClick}>
      <Card bgContent padding={0}>
        <Grid container alignItems="center" justify="center" spacing={1}>
          <Grid item xs className={classes.center}>
            <PieChart width={70} height={70}>
              <Pie
                data={getMetrics()}
                dataKey="value"
                innerRadius={25}
                outerRadius={35}
                startAngle={90}
                endAngle={-270}
              >
                <Label
                  className={classes.middleText}
                  value={`${
                    total > 0 ? Math.round((metrics.value * 100) / total) : 0
                  }%`}
                  position="center"
                  style={{ fontWeight: 'bold', fontSize: '18px' }}
                />
                <Cell fill={statusesColors[metrics.status]} />
                <Cell fill="#E0E2E3" />
              </Pie>
            </PieChart>
          </Grid>
          <Grid item xs className={classes.content}>
            <Typography
              align="center"
              variant="h4"
              style={{ fontSize: '16px' }}
            >
              <strong>{metrics.value}</strong>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              align="center"
              variant="body2"
              className={classes.text}
              component="div"
            >
              <CircleIcon
                size={14}
                color={statusesColors[metrics.status]}
                className={classes.iconStatus}
              />{' '}
              <strong>{getStatusLabel(metrics.status, true)}</strong>
              {metrics.status === statusesDashboard.NEAR_EXPIRATION ? (
                <span style={{ textAlign: 'center' }}>
                  <strong style={{ marginLeft: '10px', color: '#c01f3d' }}>
                    60 dias
                  </strong>{' '}
                  <TimerIcon
                    style={{
                      fontSize: '14px',
                      verticalAlign: 'text-top',
                      color: '#c01f3d',
                    }}
                  />
                </span>
              ) : (
                ''
              )}
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </CardActionArea>
  );
});

export default Status;
